<template>
    <router-view />
</template>
<script>
export default {

    setup() {
    },
}
</script>
<style>
    /* sweetalert2 Index property */
    .swal2-container {
        z-index: 20000 !important;
    }
</style>